import type { LocationImage as LocationImageData } from "@/lib/location-images";

/**
 * Toont de unieke afbeelding van een stad/gemeente met eigen alt-tekst en caption.
 * Er is geen fallback: als er geen eigen afbeelding is, wordt niets gerenderd.
 */
export function LocationImage({
  image,
  priority = false,
}: {
  image: LocationImageData | null;
  priority?: boolean;
}) {
  if (!image) return null;
  return (
    <figure className="overflow-hidden rounded-2xl border border-border bg-card shadow-sm">
      <img
        src={image.src}
        srcSet={image.srcSet}
        sizes="(min-width: 1024px) 720px, 100vw"
        alt={image.alt}
        title={image.title}
        width={image.width}
        height={image.height}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        {...(priority ? { fetchPriority: "high" as const } : {})}
        className="h-auto w-full object-cover"
      />
      <figcaption className="px-4 py-2.5 text-xs text-muted-foreground">{image.caption}</figcaption>
    </figure>
  );
}
